module.exports = __webpack_public_path__ + "img/es.c417a53.svg";